var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-ad" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("banner")) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              ref: "title",
              attrs: {
                "float-label": _vm.$t("title"),
                error: _vm.$v.title.$error
              },
              on: { input: _vm.$v.title.$touch },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-8" },
          [
            _c("q-select", {
              ref: "banner_type",
              attrs: {
                options: _vm.bannerTypes,
                "float-label": _vm.$t("banner_type"),
                error: _vm.$v.banner_type.$error
              },
              on: { input: _vm.$v.banner_type.$touch },
              model: {
                value: _vm.banner_type,
                callback: function($$v) {
                  _vm.banner_type = $$v
                },
                expression: "banner_type"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-select", {
              ref: "use_token",
              attrs: {
                options: _vm.use_tokens,
                "float-label": _vm.$t("use_token_on_url")
              },
              model: {
                value: _vm.use_token,
                callback: function($$v) {
                  _vm.use_token = $$v
                },
                expression: "use_token"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { helper: _vm.$t("no_www_starting_with_http_https") } },
              [
                _c("q-input", {
                  ref: "url",
                  attrs: {
                    "float-label": _vm.$t("url"),
                    error: _vm.$v.url.$error
                  },
                  on: { input: _vm.$v.url.$touch },
                  model: {
                    value: _vm.url,
                    callback: function($$v) {
                      _vm.url = $$v
                    },
                    expression: "url"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 col-sm-12 " }, [
          _c("div", { staticClass: "row gutter-sm flex" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("p", { staticClass: "caption" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "assets/banner-template-desktop.png",
                        target: "_blank"
                      }
                    },
                    [_c("q-icon", { attrs: { name: "fal fa-images" } })],
                    1
                  ),
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("desktop_banner")) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _c("uploader", {
                  attrs: {
                    content_type: "images",
                    multiple: false,
                    cropper: true,
                    aspect_ratio: 1600 / 340,
                    aspect_ratio_string: "1600/340",
                    error: _vm.$v.image_desktop.$error
                  },
                  on: {
                    fileUploaded: _vm.imageUploadedDesktop,
                    input: _vm.$v.image_desktop.$touch
                  }
                }),
                _vm.image_desktop
                  ? _c(
                      "p",
                      { ref: "image_desktop", staticClass: "q-mt-md file-url" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fal fa-check", color: "positive" }
                        }),
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.image_desktop, target: "_blank" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$truncateLink(_vm.image_desktop))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
              _c(
                "p",
                { staticClass: "caption" },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("alt_image")) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("alt_image_information_helper")) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex justify-between" },
                [
                  _vm._l(_vm.languages, function(lang) {
                    return [
                      lang.code === "pt-br"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_br_desktop",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_br_desktop.$error
                                },
                                on: {
                                  input: _vm.$v.language_br_desktop.$touch
                                },
                                model: {
                                  value: _vm.language_br_desktop,
                                  callback: function($$v) {
                                    _vm.language_br_desktop = $$v
                                  },
                                  expression: "language_br_desktop"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "en-us"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_us_desktop",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_us_desktop.$error
                                },
                                on: {
                                  input: _vm.$v.language_us_desktop.$touch
                                },
                                model: {
                                  value: _vm.language_us_desktop,
                                  callback: function($$v) {
                                    _vm.language_us_desktop = $$v
                                  },
                                  expression: "language_us_desktop"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "es-es"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_es_desktop",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_es_desktop.$error
                                },
                                on: {
                                  input: _vm.$v.language_es_desktop.$touch
                                },
                                model: {
                                  value: _vm.language_es_desktop,
                                  callback: function($$v) {
                                    _vm.language_es_desktop = $$v
                                  },
                                  expression: "language_es_desktop"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "fr-fr"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_fr_desktop",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_fr_desktop.$error
                                },
                                on: {
                                  input: _vm.$v.language_fr_desktop.$touch
                                },
                                model: {
                                  value: _vm.language_fr_desktop,
                                  callback: function($$v) {
                                    _vm.language_fr_desktop = $$v
                                  },
                                  expression: "language_fr_desktop"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "col-xs-12 col-sm-12 " }, [
          _c("div", { staticClass: "row gutter-sm flex" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("p", { staticClass: "caption" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "assets/banner-template-mobile.png",
                        target: "_blank"
                      }
                    },
                    [_c("q-icon", { attrs: { name: "fal fa-images" } })],
                    1
                  ),
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("mobile_banner")) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _c("uploader", {
                  attrs: {
                    content_type: "images",
                    multiple: false,
                    cropper: true,
                    aspect_ratio: 600 / 317,
                    aspect_ratio_string: "600/317",
                    error: _vm.$v.image_mobile.$error
                  },
                  on: {
                    fileUploaded: _vm.imageUploadedMobile,
                    input: _vm.$v.image_mobile.$touch
                  }
                }),
                _vm.image_mobile
                  ? _c(
                      "p",
                      { ref: "image_mobile", staticClass: "q-mt-md file-url" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fal fa-check", color: "positive" }
                        }),
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.image_mobile, target: "_blank" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$truncateLink(_vm.image_mobile))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
              _c(
                "p",
                { staticClass: "caption" },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("alt_image")) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("alt_image_information_helper")) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex justify-between" },
                [
                  _vm._l(_vm.languages, function(lang) {
                    return [
                      lang.code === "pt-br"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_br_mobile",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_br_desktop.$error
                                },
                                on: {
                                  input: _vm.$v.language_br_desktop.$touch
                                },
                                model: {
                                  value: _vm.language_br_mobile,
                                  callback: function($$v) {
                                    _vm.language_br_mobile = $$v
                                  },
                                  expression: "language_br_mobile"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "en-us"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_us_mobile",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_us_desktop.$error
                                },
                                on: {
                                  input: _vm.$v.language_us_desktop.$touch
                                },
                                model: {
                                  value: _vm.language_us_mobile,
                                  callback: function($$v) {
                                    _vm.language_us_mobile = $$v
                                  },
                                  expression: "language_us_mobile"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "es-es"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_es_mobile",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_es_desktop.$error
                                },
                                on: {
                                  input: _vm.$v.language_es_desktop.$touch
                                },
                                model: {
                                  value: _vm.language_es_mobile,
                                  callback: function($$v) {
                                    _vm.language_es_mobile = $$v
                                  },
                                  expression: "language_es_mobile"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "fr-fr"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_fr_mobile",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_fr_desktop.$error
                                },
                                on: {
                                  input: _vm.$v.language_fr_desktop.$touch
                                },
                                model: {
                                  value: _vm.language_fr_mobile,
                                  callback: function($$v) {
                                    _vm.language_fr_mobile = $$v
                                  },
                                  expression: "language_fr_mobile"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("q-select", {
              ref: "timezone",
              attrs: {
                options: _vm.timezones,
                "float-label": _vm.$t("timezone"),
                filter: "",
                error: _vm.$v.timezone.$error
              },
              on: { input: _vm.$v.timezone.$touch },
              model: {
                value: _vm.timezone,
                callback: function($$v) {
                  _vm.timezone = $$v
                },
                expression: "timezone"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              ref: "start_date",
              attrs: {
                type: "datetime",
                "float-label": _vm.$t("publish_date"),
                format: "DD/MM/YYYY HH:mm",
                clearable: ""
              },
              model: {
                value: _vm.start_date,
                callback: function($$v) {
                  _vm.start_date = $$v
                },
                expression: "start_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              ref: "end_date",
              attrs: {
                type: "datetime",
                "float-label": _vm.$t("end_date"),
                format: "DD/MM/YYYY HH:mm",
                clearable: ""
              },
              model: {
                value: _vm.end_date,
                callback: function($$v) {
                  _vm.end_date = $$v
                },
                expression: "end_date"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$t("areas_and_profiles")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: { val: true, label: _vm.$t("select_all_areas") },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("select-multiple", {
                      attrs: {
                        filters: _vm.area,
                        options: _vm.areas,
                        error: _vm.$v.area.$error,
                        input: _vm.$v.area.$touch
                      },
                      on: {
                        on_value: function($event) {
                          _vm.area = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: { val: true, label: _vm.$t("all") },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              ref: "profile",
                              refInFor: true,
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error)
                              },
                              on: { input: _vm.$v.profile.$touch },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-select", {
                            ref: "user_group",
                            attrs: {
                              options: _vm.user_groups,
                              "float-label": _vm.$t("groups"),
                              error: _vm.$v.user_group.$error,
                              multiple: "",
                              chips: ""
                            },
                            on: { input: _vm.$v.user_group.$touch },
                            model: {
                              value: _vm.user_group,
                              callback: function($$v) {
                                _vm.user_group = $$v
                              },
                              expression: "user_group"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-mt-md" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("status")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorStatus,
                options: _vm.statuses
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_banners" })
                }
              }
            })
          ],
          1
        ),
        _vm.showDuplicateButton
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("cancel")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "info",
                    label: _vm.$t("duplicate"),
                    icon: "fal fa-copy"
                  },
                  on: {
                    click: function($event) {
                      _vm.show_duplicate_modal = true
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c("duplicate", {
        attrs: { show: _vm.show_duplicate_modal },
        on: { hideDuplicate: _vm.hideDuplicate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }